import React from "react";
import {useNavigate} from "react-router-dom";
import {Heading} from "components";
import {Img} from "components";
import {useTranslation} from "react-i18next"

interface Props {
    className?: string;
}

export default function MainFooter({...props}: Props) {

    function getYear() {
        return new Date().getFullYear();
    }

    const currentYear = getYear()

    const navigate = useNavigate();

    const {t} = useTranslation();

    return (
        <>
            <footer
                {...props}
                className={`${props.className} md:hidden sm:hidden bg-[#333333] rounded-tr-[80px] rounded-tl-[80px] flex items-center justify-center py-10 sm:py-4`}
            >
                <div className="container-xs flex justify-center px-6">
                    <div className=" flex w-full flex-col gap-20 ">
                        <div className="sm:gap-[38px] md:gap-[57px] lg:gap-[76px] gap-[76px] flex flex-col">
                            <div className=" flex flex-col items-start gap-10">
                                <div className=" flex items-start w-full">
                                    <a href="/main">
                                        <Img
                                            src="/images/hyperionixLogoFooter.svg"
                                            alt="Footer Logo"
                                            className="w-full h-[24px] object-contain"
                                        />
                                    </a>
                                    <div className="flex ml-[476px] justify-end py-1.5">
                                        <div className="flex w-full flex-wrap justify-between gap-5">
                                            <Heading
                                                size="desktop_heading_6"
                                                as="p"
                                                className="ml-[30px] font-medium uppercase text-[#E9E9E9] w-[333px]">
                                                Hyper-consult@mail.ru
                                            </Heading>
                                            <Heading
                                                size="desktop_heading_6"
                                                as="p"
                                                className="font-medium text-[#E9E9E9]">
                                                <a href="tel:+74955427541">
                                                    +7(495)542-75-41
                                                </a>
                                            </Heading>
                                        </div>
                                    </div>
                                </div>
                                <div className="h-px w-full self-stretch bg-[#B0B0B0]"/>
                            </div>
                            <div className="grid grid-cols-3 gap-5">
                                    <ul className="fleч w-[329px] flex-col items-start self-start gap-3">
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/about")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_1.1")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/products")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_1.2")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul className="w-[333px] flex flex-col items-start self-start md:w-full ">
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/bitrix24")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_2.1-main")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/services")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_2.2-main")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                                    <ul className="fleч w-[333px] flex-col items-start">
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/projects")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF]">
                                                    {t("footer.column_3.1")}
                                                </Heading>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" rel="noreferrer"
                                               onClick={() => navigate("/main/FAQ")}
                                            >
                                                <Heading
                                                    size="desktop_body_l"
                                                    as="p"
                                                    className=" !text-[#FFFFFF] mt-3">
                                                    {t("footer.column_3.3")}
                                                </Heading>
                                            </a>
                                        </li>
                                    </ul>
                            </div>
                        </div>
                        <div className="flex flex-col gap-[38px]">
                            <div className="h-px bg-[#B0B0B0]"/>
                            <div className="flex gap-5">
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-[47.6%]">
                                    © {currentYear} {t("footer.reserved")}
                                </Heading>
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-[47.6%]">
                                    {t("footer.address")}
                                </Heading>
                                <div className="flex  flex-row gap-5">
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] w-[333px] ml-[32px]">
                                        <a href={`/docs/${t("docsPrivacy")}`} target="_blank">
                                        {t("footer.privacy")}
                                        </a>
                                    </Heading>
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] w-[333px]">
                                        <a href={`/docs/${t("docsOffer")}`} target="_blank">
                                            {t("footer.offer")}
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <footer>


                {/* MD-only Footer */}
                <div className=" md:block lg:hidden bg-[#333333] rounded-tr-[48px] rounded-tl-[48px] py-10">
                    <div className="container-xs px-5">
                        <div className=" grid w-full gap-4">
                            <a href="/main" className="grid grid-cols-2 justify-self-start">
                                <Img
                                    src="/images/hyperionixLogoFooter.svg"
                                    alt="Footer Logo"
                                    className="w-full h-[24px] object-contain"
                                />
                            </a>
                            <div className="grid grid-rows-1 py-1.5 sm:grid-rows-1">
                                <div className="grid grid-cols-2 w-full gap-2 sm:grid-cols-1">
                                    <Heading
                                        size="desktop_heading_6"
                                        as="p"
                                        className=" font-medium uppercase text-[#E9E9E9]">
                                        Hyper-consult@mail.ru
                                    </Heading>
                                    <Heading
                                        size="desktop_heading_6"
                                        as="p"
                                        className="font-medium text-[#E9E9E9] text-left">
                                        <a href="tel:+74955427541">
                                            +7(495)542-75-41
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                        <div className="h-px w-full self-stretch bg-[#B0B0B0]  md:mt-4 sm:mt-4"/>
                        <div className="grid grid-cols-3 gap-5 my-[30px]">
                            <ul className="fleч w-[329px] flex-col items-start self-start gap-3">
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/about")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF]">
                                            {t("footer.column_1.1")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/products")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF] mt-3">
                                            {t("footer.column_1.2")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>
                            <ul className="w-[333px] flex flex-col items-start self-start md:w-full ">
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/bitrix24")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF]">
                                            {t("footer.column_2.1-main")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/services")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF] mt-3">
                                            {t("footer.column_2.2-main")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>
                            <ul className="fleч w-[333px] flex-col items-start">
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/projects")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF]">
                                            {t("footer.column_3.1")}
                                        </Heading>
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer"
                                       onClick={() => navigate("/main/FAQ")}
                                    >
                                        <Heading
                                            size="desktop_body_l"
                                            as="p"
                                            className=" !text-[#FFFFFF] mt-3">
                                            {t("footer.column_3.3")}
                                        </Heading>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="flex flex-col gap-[38px]">
                            <div className="h-px bg-[#B0B0B0]"/>
                            <div className="flex sm:flex-col">
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-auto whitespace-nowrap"
                                >
                                    © {currentYear} {t("footer.reserved")}
                                </Heading>
                                <Heading
                                    size="desktop_body_s_bold"
                                    className="text-[#FFFFFFB8] w-auto whitespace-nowrap"
                                >
                                    {t("footer.address")}
                                </Heading>
                                <div className="flex flex-row gap-10 sm:gap-auto sm:mt-2">
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] ml-[120px] sm:ml-0"
                                    >

                                        <a href={`/docs/${t("docsPrivacy")}`} target="_blank">
                                        {t("footer.privacy")}
                                        </a>
                                    </Heading>
                                    <Heading
                                        size="desktop_body_s_bold"
                                        className="text-[#FFFFFFB8] whitespace-nowrap"
                                    >
                                        <a href={`/docs/${t("docsOffer")}`} target="_blank">
                                            {t("footer.offer")}
                                        </a>
                                    </Heading>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </>
    );
}
